interface FreeFormObject {
  [key: string]: any
}

export const createFormInput = (name: string, value: string) => {
  const input = document.createElement("INPUT")
  input.setAttribute("type", "hidden")
  input.setAttribute("name", name)
  input.setAttribute("value", value)
  return input
}

export default (action: string, inputs: FreeFormObject, target?: string): HTMLFormElement => {
  const form = document.createElement("form")
  form.setAttribute("method", "POST")
  form.setAttribute("action", action)
  if (target) {
    form.setAttribute("target", target)
  }
  Object.keys(inputs).forEach((key) => {
    form.appendChild(createFormInput(key, inputs[key]))
  })
  document.body.appendChild(form)
  return form
}
